import React from 'react';
import { FormattedNumber } from 'react-intl';
import { FormattedMessage } from '@99designs/frontend-components/i18n';

export interface FileSizeProps {
    value: number;
}

function FileSize({ value }: FileSizeProps) {
    let fileSize: JSX.Element;

    if (!value || value <= 0) {
        fileSize = <FormattedNumber value={0} />;
        return (
            <span>
                <FormattedMessage message={'{fileSize} bytes'} values={{ fileSize }} />
            </span>
        );
    }

    const index: number = Math.floor(Math.log(value) / Math.log(1024));
    const formattedBytes: number = parseFloat((value / Math.pow(1024, index)).toFixed(2));

    const message = [
        '{fileSize} bytes',
        '{fileSize}KB',
        '{fileSize}MB',
        '{fileSize}GB',
        '{fileSize}TB',
        '{fileSize}PB',
    ][index];

    fileSize = <FormattedNumber value={formattedBytes} />;
    return (
        <span>
            <FormattedMessage message={message} values={{ fileSize }} />
        </span>
    );
}

export default FileSize;
